<div class="skeleton-loader">
   
    <ng-container *ngIf="reportType === 'searchloader'">
        <div class="searching-loader">
            <div class="circle-section">
                <div class="circle loader-body" [ngStyle]="{'height': height, 'width': width}"></div>
            </div>
            <div class="searching-loader-row">
                <div class="loader-body l1" style="width: 100px; height: 6px; border-radius: 99px;"></div>
                <div class="loader-body l2" style="width: 50px; height: 6px;  border-radius: 99px;"></div>
            </div>
        </div>
    </ng-container>

</div>